import Logo from "../Logo";
import PageHeading from "../PageHeading";

export default function Header() {
  return (
    <header className="header">
      <Logo />
      <PageHeading />
    </header>
  );
}
